import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getFirestore, collection, addDoc } from "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries

import sendMail from "./email";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAJLTZNUREFdasw17u_N9-hyH22X1M2610",
  authDomain: "personal-website-3535f.firebaseapp.com",
  projectId: "personal-website-3535f",
  storageBucket: "personal-website-3535f.appspot.com",
  messagingSenderId: "593501592864",
  appId: "1:593501592864:web:1fe830e73e79bc7ad4cb45",
  measurementId: "G-G1LZN5ZH9K",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

const markUserEntry = () => {
  console.log(logEvent(analytics, "login"));
};

/**
 * Inserts a visitor's message into the datastore.
 * @param {string} name Their name.
 * @param {string} email Their email.
 * @param {string} message The message they sent.
 */
const addMessage = async (name, email, message) => {
  try {
    const messageObj = {
      name,
      email,
      message,
      time: new Date().toUTCString(),
      ipInfo: await fetch("https://freeipapi.com/api/json/").then((r) =>
        r.json()
      ),
    };
    await addDoc(collection(db, "visitor-messages"), messageObj);
    await sendMail(messageObj);
  } catch (e) {}
};

export { addMessage, markUserEntry };
